import { FilterKey, FilterParams } from '../../Entities/Search/QueryParams.entity';
import { Filter } from '../../Entities/Search/SearchFilters/Filter.entity';

const MULTI_VALUES_FILTERS: FilterKey[] = [
  'make',
  'model',
  'color',
  'doors',
  'seats',
  'body-type',
  'fuel-type',
  'variant-type',
];

export const createFiltersList = (filterParams: FilterParams): Filter[] => {
  return (Object.keys(filterParams) as FilterKey[]).flatMap(key => {
    let value = filterParams[key];

    if (MULTI_VALUES_FILTERS.includes(key) && !Array.isArray(value)) {
      value = [value!];
    }

    return [{ id: key, value }];
  });
};
